import axios from 'axios';
import { FETCH_PRODUCT_URL, APP_DOMAIN } from 'appenv';

const fetchSearchedProducts = async (
  query: string,
  pageSize = 50,
  page = 0,
) => {
  try {
    const domain = APP_DOMAIN;
    const searchProductsResponse = await axios.get(`${FETCH_PRODUCT_URL}/products/search`, {
      params: {
        q: query,
        domain,
        pageSize,
        page,
      },
    });
    return searchProductsResponse.data;
  } catch (_) {
    return null;
  }
};

export default fetchSearchedProducts;
